import { palette } from '../palette';


const MuiTab = {
  styleOverrides: {
    root: ({theme} : any) => ({
      '&.MuiTab-root': {
        textTransform: 'none',
        fontWeight: '400',
        fontSize: '1.25rem',
        color: theme.palette.text.primary,
      },

      '&.Mui-selected': {
        color: theme.palette.text.primary,
        fontWeight: '600',
          paddingBlock: '32px',
      },
    }),
  },
};

export default MuiTab;



